import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', 
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'recupero-password',
    loadChildren: () => import('./pages/modal/recupero-password/recupero-password.module').then( m => m.RecuperoPasswordPageModule)
  },
  {
    path: 'reset-password/:token',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'register-utente',
    loadChildren: () => import('./pages/register-utente/register-utente.module').then( m => m.RegisterUtentePageModule)
  },
  {
    path: 'register-impresa',
    loadChildren: () => import('./pages/register-impresa/register-impresa.module').then( m => m.RegisterImpresaPageModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'edit-profile',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/edit-profile/edit-profile.module').then( m => m.EditProfilePageModule)
  },
  {
    path: 'compra',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/compra/compra.module').then( m => m.CompraPageModule)
  },
  {
    path: 'wallet',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/wallet/wallet.module').then( m => m.WalletPageModule)
  },
  {
    path: 'servizi',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/servizi/servizi.module').then( m => m.ServiziPageModule)
  },
  {
    path: 'richiedi-servizi',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/richiedi-servizi/richiedi-servizi.module').then( m => m.RichiediServiziPageModule)
  },
  {
    path: 'search-filter',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/search-filter/search-filter.module').then( m => m.SearchFilterPageModule)
  },
  {
    path: 'cart-modal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/cart-modal/cart-modal.module').then( m => m.CartModalPageModule)
  },
  {
    path: 'descrizione-transazione/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/descrizione-transazione/descrizione-transazione.module').then( m => m.DescrizioneTransazionePageModule)
  },
  {
    path: 'prodotti',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/prodotti/prodotti.module').then( m => m.ProdottiPageModule)
  },
  {
    path: 'nuovo-prodotto',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/nuovo-prodotto/nuovo-prodotto.module').then( m => m.NuovoProdottoPageModule)
  },
  {
    path: 'nuovo-servizio',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/nuovo-servizio/nuovo-servizio.module').then( m => m.NuovoServizioPageModule)
  },
  {
    path: 'ordini',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/ordini/ordini.module').then( m => m.OrdiniPageModule)
  },
  {
    path: 'richiesta',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/richiesta/richiesta.module').then( m => m.RichiestaPageModule)
  },
  {
    path: 'segnalazione',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/segnalazione/segnalazione.module').then( m => m.SegnalazionePageModule)
  },
  {
    path: 'feedback',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/feedback/feedback.module').then( m => m.FeedbackPageModule)
  },
  {
    path: 'infofeedback',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/infofeedback/infofeedback.module').then( m => m.InfofeedbackPageModule)
  },
  {
    path: 'richieste-mie',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/richieste-mie/richieste-mie.module').then( m => m.RichiesteMiePageModule)
  },
  {
    path: 'richieste-miei-servizi',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/richieste-miei-servizi/richieste-miei-servizi.module').then( m => m.RichiesteMieiServiziPageModule)
  },
  {
    path: 'popover',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/popover/popover.module').then( m => m.PopoverPageModule)
  },
  {
    path: 'aggiorna-prodotto/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/aggiorna-prodotto/aggiorna-prodotto.module').then( m => m.AggiornaProdottoPageModule)
  },
  {
    path: 'ordini-da-evadere',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/ordini-da-evadere/ordini-da-evadere.module').then( m => m.OrdiniDaEvaderePageModule)
  },
  {
    path: 'donazione',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/donazione/donazione.module').then( m => m.DonazionePageModule)
  },
  {
    path: 'donazione-modal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/donazione-modal/donazione-modal.module').then( m => m.DonazioneModalPageModule)
  },
  {
    path: 'chat/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'lista-chat',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/lista-chat/lista-chat.module').then( m => m.ListaChatPageModule)
  },
  {
    path: 'aggiorna-servizio/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/aggiorna-servizio/aggiorna-servizio.module').then( m => m.AggiornaServizioPageModule)
  },
  {
    path: 'search-filter-ordini',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/search-filter-ordini/search-filter-ordini.module').then( m => m.SearchFilterOrdiniPageModule)
  },
  {
    path: 'search-filter-ordini-da-evadere',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/search-filter-ordini-da-evadere/search-filter-ordini-da-evadere.module').then( m => m.SearchFilterOrdiniDaEvaderePageModule)
  },
  {
    path: 'campagne',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/campagne/campagne.module').then( m => m.CampagnePageModule)
  },
  {
    path: 'le-mie-campagne',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/le-mie-campagne/le-mie-campagne.module').then( m => m.LeMieCampagnePageModule)
  },
  {
    path: 'lista-richieste-campagne/:idcampagna',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/lista-richieste-campagne/lista-richieste-campagne.module').then( m => m.ListaRichiesteCampagnePageModule)
  },
  {
    path: 'richiesta-campagna/:idcampagna',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/richiesta-campagna/richiesta-campagna.module').then( m => m.RichiestaCampagnaPageModule)
  },
  {
    path: 'search-filter-campagne',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/search-filter-campagne/search-filter-campagne.module').then( m => m.SearchFilterCampagnePageModule)
  },
  {
    path: 'aggiorna-richiesta-campagna/:idrichiesta/:idcampagna',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/aggiorna-richiesta-campagna/aggiorna-richiesta-campagna.module').then( m => m.AggiornaRichiestaCampagnaPageModule)
  },
  {
    path: 'my-feedback',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/my-feedback/my-feedback.module').then( m => m.MyFeedbackPageModule)
  },
  {
    path: 'modifica-feedback/:id/:tipo',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modifica-feedback/modifica-feedback.module').then( m => m.ModificaFeedbackPageModule)
  },
  {
    path: 'search-filter-option',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/search-filter-option/search-filter-option.module').then( m => m.SearchFilterOptionPageModule)
  },
  {
    path: 'dispositivi',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dispositivi/dispositivi.module').then( m => m.DispositiviPageModule)
  },
  {
    path: 'carosello',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/modal/carosello/carosello.module').then( m => m.CaroselloPageModule)
  },
  {
    path: 'inizio',
    loadChildren: () => import('./pages/modal/inizio/inizio.module').then( m => m.InizioPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, useHash:false, onSameUrlNavigation: 'reload', relativeLinkResolution: 'corrected'})
    // RouterModule.forRoot(routes, {relativeLinkResolution: 'corrected' })
    // RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
